import * as React from 'react';
import { AutoScaledImage } from '@helpcenter/auto-scaled-image';
import { BreadCrumbs } from 'view/common/bread-crumbs';
import {
	SubHeadingContainer,
	IconContainer,
	SubHeading,
	Description,
} from 'view/common/paper-header/styled';
import Heading from '@atlaskit/heading';
import { UseTypographyMigratedComponent } from '@atlassian/help-center-common-util/enable-typography-migration';

export interface PaperHeaderProps {
	subHeading: string | undefined;
	description: string | undefined;
	logoUrl?: string | undefined;
	portalId?: number;
	categoryId?: string;
	showRequestsInBreadcrumbs?: boolean;
	dangerouslyAllowHtmlInDescription?: boolean;
	requestKey?: string | undefined;
	requestUrl?: string | undefined;
	dataTestId?: string;
	additionalBreadCrumbs?: React.ReactElement[];
}

const headerDescription = (description: string, dangerouslyAllowHtmlInDescription?: boolean) =>
	dangerouslyAllowHtmlInDescription ? (
		<Description dangerouslySetInnerHTML={{ __html: description }} />
	) : (
		<Description>{description}</Description>
	);

const PaperHeader: React.FC<PaperHeaderProps> = ({
	subHeading,
	description,
	logoUrl,
	showRequestsInBreadcrumbs,
	dangerouslyAllowHtmlInDescription,
	dataTestId,
	...props
}) => {
	return (
		<div data-testid={dataTestId}>
			<BreadCrumbs {...props} showRequests={showRequestsInBreadcrumbs} />

			<SubHeadingContainer>
				{!!logoUrl && (
					<IconContainer>
						<AutoScaledImage src={logoUrl} alt="" />
					</IconContainer>
				)}
				<div>
					<UseTypographyMigratedComponent
						migratedComponent={
							<Heading size="large" as="h1">
								{subHeading}
							</Heading>
						}
					>
						<SubHeading>{subHeading}</SubHeading>
					</UseTypographyMigratedComponent>
				</div>
			</SubHeadingContainer>

			{!!description && headerDescription(description, dangerouslyAllowHtmlInDescription)}
		</div>
	);
};

export default PaperHeader;
